import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/auth";
import { useCredentialsClient } from "@/features/credentials/hooks/use-credentials-client";
import { credentialsQueryKeys } from "@/features/credentials/queries/credentials-query-keys";

export function useCredentialsListQuery({
  sport,
  organizationId,
}: {
  sport: string;
  organizationId: string;
}) {
  const { productToken } = useAuth();
  const credentialsClient = useCredentialsClient();

  return useQuery({
    queryKey: credentialsQueryKeys.list({ sport, organizationId }),
    queryFn: () =>
      credentialsClient.getCredentialsList({
        productToken: productToken as string,
        sport,
        organizationId,
      }),
    enabled: !!productToken && !!sport && !!organizationId,
    select: (response) =>
      [...response.data].sort((a, b) => a.name.localeCompare(b.name)),
  });
}
